import React, { useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import ColorModeContext from "../../layout/themeContext";
import { openApi } from "../../services/api";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#0a0a0a",
    },
    card: {
        width: "100%",
        maxWidth: 420,
        backgroundColor: "#111",
        borderRadius: 20,
        padding: "40px 32px",
        boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
    },
    title: {
        color: "#fff",
        fontWeight: 700,
        fontSize: "1.4rem",
        marginBottom: 8,
        textAlign: "center",
    },
    subtitle: {
        color: "#9ca3af",
        fontSize: "0.85rem",
        marginBottom: 24,
        textAlign: "center",
    },
    inputLabel: {
        color: "#d1d5db",
        fontSize: "0.82rem",
        fontWeight: 600,
        marginBottom: 6,
        display: "block",
    },
    textField: {
        marginBottom: 20,
        '& .MuiOutlinedInput-root': {
            borderRadius: 10,
            backgroundColor: "rgba(255,255,255,0.06)",
            color: "#fff",
            '& fieldset': { borderColor: "rgba(255,255,255,0.12)" },
            '&:hover fieldset': { borderColor: "rgba(255,255,255,0.25)" },
            '&.Mui-focused fieldset': { borderColor: "#6366f1" },
        },
        '& .MuiInputBase-input': { color: "#fff" },
    },
    submitButton: {
        borderRadius: 10,
        textTransform: "none",
        fontWeight: 700,
        padding: "10px 0",
        fontSize: "0.95rem",
        backgroundColor: "#6366f1",
        color: "#fff",
        marginBottom: 16,
        '&:hover': { backgroundColor: "#4f46e5" },
    },
    backLink: {
        color: "#6366f1",
        fontSize: "0.85rem",
        textAlign: "center",
        cursor: "pointer",
        display: "block",
        '&:hover': { textDecoration: "underline" },
    },
    successBox: {
        textAlign: "center",
        color: "#10b981",
        fontSize: "0.9rem",
        padding: "16px",
        backgroundColor: "rgba(16,185,129,0.1)",
        borderRadius: 10,
        marginBottom: 16,
    },
}));

const ForgotPassword = () => {
    const classes = useStyles();
    const history = useHistory();
    const { colorMode } = useContext(ColorModeContext);
    const { appLogoFavicon, appName } = colorMode;
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email) return;

        setLoading(true);
        try {
            await openApi.post("/auth/forgot-password", { email });
            setSent(true);
        } catch (err) {
            toast.error("Erro ao enviar email. Tente novamente.");
        }
        setLoading(false);
    };

    return (
        <>
            <Helmet>
                <title>Recuperar Senha - {appName || "Sistema"}</title>
                <link rel="icon" href={appLogoFavicon || "/default-favicon.ico"} />
            </Helmet>
            <div className={classes.root}>
                <div className={classes.card}>
                    <Typography className={classes.title}>
                        Recuperar Senha
                    </Typography>
                    <Typography className={classes.subtitle}>
                        {sent
                            ? "Verifique sua caixa de entrada"
                            : "Informe seu e-mail para receber o link de recuperação"}
                    </Typography>

                    {sent ? (
                        <>
                            <div className={classes.successBox}>
                                ✅ Se o e-mail estiver cadastrado, você receberá um link para redefinir sua senha.
                            </div>
                            <span
                                className={classes.backLink}
                                onClick={() => history.push("/login")}
                            >
                                Voltar ao Login
                            </span>
                        </>
                    ) : (
                        <form onSubmit={handleSubmit}>
                            <label className={classes.inputLabel}>E-mail</label>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                placeholder="Digite seu e-mail"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                size="small"
                                className={classes.textField}
                                type="email"
                            />
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                className={classes.submitButton}
                                disabled={loading}
                            >
                                {loading ? "Enviando..." : "Enviar link de recuperação"}
                            </Button>
                            <span
                                className={classes.backLink}
                                onClick={() => history.push("/login")}
                            >
                                Voltar ao Login
                            </span>
                        </form>
                    )}
                </div>
            </div>
        </>
    );
};

export default ForgotPassword;
